export default __webpack_public_path__ + "static/media/facebook-right-column.ce21081c.jpg";